import { LuFileText, LuImageOff } from 'react-icons/lu';
import type { StagingRow } from '../../schema';

interface Props {
  row: StagingRow;
  onView: (row: StagingRow) => void;
}

/** Source preview. Image messages show a thumbnail; text messages (the common
 *  case) show a document icon — clicking either opens the review dialog. */
export function SourcePhotoThumb({ row, onView }: Props) {
  const isImage =
    !!row.sourcePhotoUrl && (row.sourceMimeType ?? '').startsWith('image/');

  return (
    <div className="flex h-full items-center justify-center">
      {isImage ? (
        <button
          type="button"
          onClick={() => onView(row)}
          className="overflow-hidden rounded-md ring-1 ring-border transition hover:ring-primary"
          aria-label="View source photo"
        >
          <img
            src={row.sourcePhotoUrl ?? undefined}
            alt="Source"
            className="h-9 w-9 object-cover"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </button>
      ) : row.sourcePhotoUrl ? (
        <button
          type="button"
          onClick={() => onView(row)}
          className="text-foreground-muted transition hover:text-primary"
          title="Text message — open review"
          aria-label="View source message"
        >
          <LuFileText size={16} />
        </button>
      ) : (
        <span className="text-foreground-muted" title="No source">
          <LuImageOff size={16} />
        </span>
      )}
    </div>
  );
}
